var _defs, _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack401({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 5.45,
    cy: 8,
    rx: 5.12,
    ry: 5.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.64,10V5.84h.45V7.92L4.81,5.84h.61L4,7.54,5.49,10H4.88L3.66,7.91l-.57.67V10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.86,10V5.84h1.3a1.89,1.89,0,0,1,.67.08.89.89,0,0,1,.48.4A1.37,1.37,0,0,1,8.49,7,1.46,1.46,0,0,1,8.2,8a1.22,1.22,0,0,1-1,.36H6.32V10Zm.46-2.21h.89a.83.83,0,0,0,.61-.19A.76.76,0,0,0,8,7.07a.83.83,0,0,0-.1-.43.49.49,0,0,0-.23-.24,1.12,1.12,0,0,0-.49-.07H6.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.15,10V5.84h1.29a1.34,1.34,0,0,1,.62.12.93.93,0,0,1,.38.38,1.1,1.1,0,0,1,.14.57,1.14,1.14,0,0,1-.12.52,1,1,0,0,1-.36.37,1,1,0,0,1,.48.37,1.21,1.21,0,0,1,.17.65,1.35,1.35,0,0,1-.16.67.88.88,0,0,1-.42.41,1.54,1.54,0,0,1-.71.14ZM13.6,7.6h.75a1.35,1.35,0,0,0,.41,0,.58.58,0,0,0,.28-.2A.73.73,0,0,0,15.13,7a.7.7,0,0,0-.08-.37.51.51,0,0,0-.23-.21,1.62,1.62,0,0,0-.53-.06H13.6Zm0,1.94h.86a1.4,1.4,0,0,0,.42,0,.57.57,0,0,0,.3-.25.87.87,0,0,0,.1-.42.76.76,0,0,0-.1-.41.55.55,0,0,0-.26-.24,1.34,1.34,0,0,0-.52-.07h-.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack401);
export default __webpack_public_path__ + "static/media/Symbol_pack_401.e8153558318bf3422ec8baf2747f22a1.svg";
export { ForwardRef as ReactComponent };